<template>
<div id="loader" class="section">

  <div class="svg-container">
    <div class="svg-overlay">

      <svgCircleText></svgCircleText>
    </div>

    <svgCircle></svgCircle>
  </div>
  <div class="_text-wrapper has-text-centered">
    <p class="el-p">...................................................</p>
    <p class="el-p"><strong>** warning ** </strong>- OPEN ACCESS IS ON </p>
    <p class="el-p">CONTACT <a href="mailto:DOU@NIKE.COM">DOU@NIKE.COM</a> TO RESET PASSWORD</p>
    <p class="el-p">...................................................</p>

  </div>
  <div v-if="!isMobile" class="_text-wrapper has-text-centered">

    <div class="columns">
      <div class="column is-narrow">
        <p class="el-p username">USERNAME</p>
      </div>
      <div class="column">
        <p class="login el-p glitch-1" data-text='*§*++"*"*!**?*'>
          <vue-typer :repeat='0' :shuffle='false' initial-action='typing' :pre-type-delay='2000' :type-delay='100' :pre-erase-delay='2000' :erase-delay='250' erase-style='select-all' :erase-on-complete='false' caret-animation='blink' text='************'></vue-typer>
        </p>
      </div>
    </div>

    <div class="columns">
      <div class="column is-narrow">
        <p class="el-p username">PASSWORD</p>
      </div>
      <div class="column">
        <p class="login  el-p glitch-2" data-text='$%$§=($*)//"§"*"!*'>
          <vue-typer :repeat='0' :shuffle='false' initial-action='typing' :pre-type-delay='4000' :type-delay='100' :pre-erase-delay='2000' :erase-delay='250' erase-style='select-all' :erase-on-complete='false' caret-animation='blink' text='*****************'></vue-typer>
        </p>
      </div>
    </div>

  </div>

  <div class="_text-wrapper">

    <div class="columns">
      <div class="column" v-if="isMobile">
        <p>Please stand by</p>
        <p class="el-p">...................................................</p>

      </div>
      <div class="column" :class="loadingStatus == 100 ? 'warning' : ''">
        <p class="el-p" style="padding-left: 0.5em">{{ loadingStatus != 100 ? 'Initializing' : 'Initializing complete'}}
          <!-- <div v-if="!isMobile"> -->

          <vue-typer v-if="loadingStatus != 100 && !isMobile" :shuffle='false' initial-action='typing' :pre-type-delay='0' :type-delay='50' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='true' caret-animation='blink' text='...........................'></vue-typer>
          <!-- </div> -->
        </p>
      </div>

      <div class="column is-narrow is-narrow-mobile">
        <p class="el-p" :style=" isMobile ? '' :'text-align: right;'">{{loadingStatus + '%'}}</p>
      </div>

    </div>
    <!-- <div class="columns">
      <div class="column ">
        <transition name="translate-in">
          <p class="start-button" @click="handleClick" v-show="loadingStatus == 100">Start</p>
        </transition>
      </div>
    </div> -->
  </div>
</div>
</template>

<script>
import svgCircle from './svgCircle.vue'
import svgCircleText from './svgCircleText.vue'
import anime from 'animejs';
import {
  VueTyper
} from 'vue-typer'


export default {
  name: 'loadingScren',
  props: ['isMobile'],
  data() {
    return {
      loadingStatus: 0
    }
  },
  components: {
    svgCircle,
    svgCircleText,
    VueTyper
  },
  methods: {
    handleClick() {
      this.$root.$emit('startRender')
    },
    preLoadStatus(e) {
      // setTimeout(() => {
      this.loadingStatus = Math.round(e * 100) / 100
      // }, 5000)
      if (e == 100) {
        // document.querySelector('.svg-container').style.opacity = 0;
        setTimeout(() => {
          this.handleClick()

        }, 500)

      }
    },

  },
  mounted() {
    this.$root.$on('preLoadStatus', (e) => this.preLoadStatus(e))
    this.$nextTick(() => {
      if (this.isMobile) {
        return
      }
      // put code here
      anime({
        targets: '.el-p',
        // filter: ["blur(5px)", "blur(0px)"],
        // translateZ: [-200, 0],
        opacity: [0, 1],
        easing: 'easeInQuad',
        // easing: 'spring(1, 80, 10, 0)',

        duration: 1000,
        // delay: 30000,

        delay: anime.stagger(150), // increase delay by 100ms for each elements.
      });


    })
  }
}
</script>

<style lang="scss">
strong {
    color: inherit;
    animation: warning 666ms alternate infinite linear;
}
.warning {
    animation: warning 111ms alternate infinite linear;

}

#loader {
    // background: red;
    // transition: background-color 0.25s ease;
    // @include scanlines(rgba(0, 255, 0, 1), 1px, 0deg, 0.1);
}

.translate-in-enter-active {
    transition: transform 1s ease, opacity 0.85s ease;
}

.translate-in-leave-active {
    transition: transform 1s;
}
/* .fade-leave-active below version 2.1.8 */
.translate-in-enter,
.translate-in-leave-to {
    transform: translateY(-15px);
    // filter: blur(2px);
    opacity: 0;
}
// .start-button {
//     border: 1px solid green;
//     display: block;
//     padding: 0.5em;
//     margin: 0.5em;
//     width: calc(100% - 0.5em);
//     text-align: center;
//     // transform: translateY(0px);
//     // opacity: 1;
//     background: black;
//     cursor: pointer;
//     transition: transform 1s ease, opacity 0.85s ease;
// }
// .start-button:hover {
//     filter: drop-shadow(0 0 25px #00ff00);
//     transform: translateY(-5px);
// }
@keyframes warning {
    0% {
        color: rgba(0, 255, 0, 0.25);
        /* color: inherit !important; */
    }
    100% {
        color: rgba(0, 255, 0, 1);
    }
}

a {
    color: rgba(0, 255, 0, 1);
    &:hover {
        border-bottom: 1px rgba(0, 255, 0, 1) solid;
    }
}

._text-wrapper {
    max-width: 500px;
    margin: 0 auto;
    padding-top: 2em;
    clear: both;
}

.vue-typer .char {
    color: rgba(0, 255, 0, 1)!important;
}
.login {
    float: right;
    padding: 0.5em;
    border: 1px solid rgba(0, 255, 0, 1);
    width: 100%;
    text-align: left;
}
.username {
    float: left;
    padding: 0.5em;

}

.svg-container {
    max-width: 375px;
    min-width: 200px;
    min-height: 375px;
    height: 100%;
    margin: 0 auto;
    perspective: 800;
    transition: opacity 0.25s ease;
    /* position: absolute; */
}

.svg-overlay {
    /* max-width: 375px;
  min-width: 2px; */
    width: 100%;
    /* position: absolute; */
    /* perspective: 800; */
}

path {
    perspective: 800;

}

#loader {
    // height: 100%;
    // max-width: 500px;
    // margin: 0 auto;
    // position: relative;
    // background: black;
}

@media only screen and (max-width: 600px) {
    ._text-wrapper {
        padding-top: 0;
        text-align: center;
    }
    .svg-container {
        min-height: 340px;
    }
}
</style>
